module.exports = __webpack_public_path__ + "static/media/1.ec7b4c3f.png";